import React from 'react';
import PrivateRoute from 'components/PrivateRoute';
import  Settings from 'pages/Settings';
import  Results from 'pages/PresidentiaResult';
import OfficersList from 'pages/OfficersList';
import OfficerDetails from 'pages/OfficerDetails';
import EditOfficer from 'pages/EditOfficer';
import AssignOfficerToConstituency from 'pages/AssignOfficerToConstituency';
import ConstituenciesList from 'pages/ConstituenciesList';
import EditResultPage from "pages/EditResultPage";
import PollingStation from "pages/pollingStation";



const Live = React.lazy(() => import('pages/Live'));
const Historical = React.lazy(() => import('pages/Historical'));
const Login = React.lazy(() => import('pages/Login'));

export interface RouteType {
    path: string;
    element: React.ReactNode;
}

export const routes: RouteType[] = [
    {
        path: '/',
        element: (
            <PrivateRoute>
                <Live />
             </PrivateRoute>
        ),
    },
    {
        path: '/historical',
        element: (
            <PrivateRoute>
                <Historical />
             </PrivateRoute>
        ),
    },
    {
        path: '/polling-station',
        element: (
            <PrivateRoute>
                <PollingStation />
             </PrivateRoute>
        ),
    },
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '*',
        element: (
            <PrivateRoute>
                <Live />
            </PrivateRoute>
        ),
    },
    {
        path: '/settings',
        element: (
            <PrivateRoute>
                <Settings />
            </PrivateRoute>
        ),
    },
    {
        path: '/results',
        element: (
            <PrivateRoute>
                <Results />
            </PrivateRoute>
        ),
    },
    {
        path: '/results/edit/:id',
        element: (
            <PrivateRoute>
                <EditResultPage />
            </PrivateRoute>
        ),
    },
    {
        path: '/officers',
        element: (
            <PrivateRoute>
                <OfficersList />
            </PrivateRoute>
        ),
    },
    {
        path: '/officers/:id',
        element: (
            <PrivateRoute>
                <OfficerDetails />
            </PrivateRoute>
        ),
    },
    {
        path: '/officers/edit/:id',
        element: (
            <PrivateRoute>
                <EditOfficer />
            </PrivateRoute>
        ),
    },
    {
        path: '/settings/assign-officer',
        element: (
            <PrivateRoute>
                <AssignOfficerToConstituency />
            </PrivateRoute>
        ),
    },
    {
        path: '/settings/constituencies',
        element: (
            <PrivateRoute>
                <ConstituenciesList />
           </PrivateRoute>
        ),
    },
];